module.exports = __webpack_public_path__ + "static/media/ic_alipay.7a032a50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_alipay.svg
// module id = 122
// module chunks = 0